import { Theme } from '@mui/material/styles';

export default function SvgIcon(theme: Theme): unknown {
  return {
    MuiSvgIcon: {
      fill: theme.palette.grey[800],
      styleOverrides: {
        fontSizeSmall: {
          width: 20,
          height: 20,
          fontSize: 'inherit',
        },
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: 'inherit',
        },
      },
    },
  };
}
